/** Boards' data in the query cache (apps/boards): everything under it is fetched again when a board one sees changes */
export const boardsKey = ['boards'] as const
